export enum LibraryMasters {
  MEDIA = "MEDIA",
  BOOK_CATEGORY = "BOOK_CATEGORY",
  DEPARTMENT = "DEPARTMENT",
  SUBJECTS = "SUBJECTS",
  PUBLISHER = "PUBLISHER",
  AUTHOR = "AUTHOR",
  VENDOR = "VENDOR",
}
